import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=01c452fe&scoped=true"
import script from "./Accident.vue?vue&type=script&lang=js"
export * from "./Accident.vue?vue&type=script&lang=js"
import style0 from "./Accident.vue?vue&type=style&index=0&id=01c452fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c452fe",
  null
  
)

export default component.exports